import React from 'react';
import { BackendInvoiceStatus } from '../api/billingApi';

export type UIInvoiceStatus = 'Draft' | 'Sent' | 'Partial Paid' | 'Paid' | 'Overdue';

interface Props {
  status: BackendInvoiceStatus | UIInvoiceStatus; // Allow both backend enum and UI string
}

export default function StatusBadge({ status }: Props) {
  // Map backend enum to UI string for consistent display
  const displayStatus: UIInvoiceStatus = typeof status === 'number' ?
    (status === BackendInvoiceStatus.Draft ? 'Draft' :
    status === BackendInvoiceStatus.Sent ? 'Sent' :
    status === BackendInvoiceStatus.PartialPaid ? 'Partial Paid' :
    status === BackendInvoiceStatus.Paid ? 'Paid' :
    'Overdue') : status;

  const configs: Record<UIInvoiceStatus, string> = {
    Draft: 'bg-strivre-softgrey text-slate-600 border-strivre-lightnavy',
    Sent: 'bg-strivre-lightburgundy text-strivre-burgundy border-strivre-lightburgundy',
    'Partial Paid': 'bg-amber-50 text-amber-600 border-amber-100',
    Paid: 'bg-emerald-50 text-emerald-600 border-emerald-100',
    Overdue: 'bg-red-50 text-red-600 border-red-100',
  };

  return ( // Use displayStatus for rendering
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold border ${configs[displayStatus]}`}>
      {displayStatus}
    </span>
  );
}